import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from '../../../services/authorization.service';
import { ConfigService } from '../../../services/config.service';
import { OrderService } from '../../../services/order.service';

@Component({
  selector: 'app-quote-cfd',
  templateUrl: './quote-cfd.component.html',
  styleUrls: ['./quote-cfd.component.css']
})
export class QuoteCfdComponent implements OnInit {

  private readonly _orderService: OrderService;
  private readonly _authorizationService: AuthorizationService;
  private readonly _configService: ConfigService;

  enteredByUserRole : string | null = null;

  constructor(orderService: OrderService, authorizationService: AuthorizationService, configService: ConfigService) {
    this._orderService = orderService;
    this._authorizationService = authorizationService;
    this._configService = configService;
  }

  ngOnInit(): void {
    if(this._orderService.orderDto?.enteredBy){
      this.getRoleBasedOnUserId(this._orderService.orderDto?.enteredBy);
    }
  }
  async getRoleBasedOnUserId(userLoginId: string) {
    const msId = this._authorizationService.getMyMSId();

    if (localStorage.getItem('impersonateType') !== null && localStorage.getItem('impersonateType') !== ''
    && this._orderService.orderDto?.enteredBy === msId.toUpperCase()) {
      this.enteredByUserRole = localStorage.getItem('rolename')?.replace(' ','') ?? '';
    }
    else {
      const data = await this._authorizationService.getRoleBasedOnUserId(this._configService.apiUrl, userLoginId)
      if (data) {
        this.enteredByUserRole = data.role;
      }
    }
  }
}
